// Vendor
import React from "react";
import { storiesOf } from "@storybook/react";
import { withKnobs, text } from "@storybook/addon-knobs/react";
import withReadme from "storybook-readme/with-readme";

// emcm-ui
import StaticRenderer from "@emcm-ui/component-static-renderer";
import { Language } from "@emcm-ui/component-theme";
import Block from "@emcm-ui/component-block";
import Grid from "@emcm-ui/component-grid";
import Section from "@emcm-ui/component-section";
import {
  AjaxContentWithContext,
  AjaxContentContainer
} from "@emcm-ui/component-ajax-content";

// Local
import "./VerticalNav.css";
import VerticalNav from "./index";
import VerticalNavREADME from "../README.md";
import Icon from "@emcm-ui/component-icon";

const stories = storiesOf("Components/VerticalNav", module);

stories.addDecorator(withKnobs);
stories.addDecorator(withReadme(VerticalNavREADME));

stories
  .add("Default", () => (
    <div style={{ width: "360px" }}>
      <VerticalNav>
        <VerticalNav.Menu label="Overview">
          <VerticalNav.Item label="Overview 1" href="#" />
          <VerticalNav.Item label="Overview 2" href="#" />
        </VerticalNav.Menu>
        <VerticalNav.Menu label="Development">
          <VerticalNav.Item label="Transport API - C Edition" href="#" />
          <VerticalNav.Item label="Message API - C++ Edition" href="#" />
          <VerticalNav.Menu label="MRN Datebase Models & Implementation Guide">
            <VerticalNav.Item label="Introductions" href="#" />
            <VerticalNav.Item label="Real-time news" href="#" />
            <VerticalNav.Menu label="Story Construction & News Coding">
              <VerticalNav.Item
                label="Nested listing A"
                href="#"
                isSelected={true}
                iconType={
                  <Icon path="./icons/ui/grey/document-07.svg" size="s" />
                }
              />

              <VerticalNav.Menu label="Won't work">
                <VerticalNav.Item label="Nested listing A" href="#" />
                <VerticalNav.Item label="Nested listing B" href="#" />
              </VerticalNav.Menu>
            </VerticalNav.Menu>
          </VerticalNav.Menu>
        </VerticalNav.Menu>
        <VerticalNav.Item label="FAQs" href="#" />
        <VerticalNav.Item label="Release Notes" href="#" />
      </VerticalNav>
    </div>
  ))
  .add("AjaxContext", () => (
    <Section>
      <AjaxContentContainer>
        <Grid variant="even-2">
          <Grid.Item>
            <VerticalNav>
              <VerticalNav.Menu label="Todos">
                <VerticalNav.Item
                  label="One Todo"
                  href="http://demo4923211.mockable.io/ajaxcontenttest2"
                  isSelected={true}
                  isAjax={true}
                />
                <VerticalNav.Item
                  label="Two Todos"
                  href="https://jsonplaceholder.typicode.com/todos/2"
                  isAjax={true}
                />
              </VerticalNav.Menu>
            </VerticalNav>
          </Grid.Item>
          <Grid.Item>
            <AjaxContentWithContext
              failedContent={text(
                "failedContent",
                "Failed to retrieve content"
              )}
              loadingLabel={text("loadingLabel", "Loading")}
              minHeight={parseInt(text("minHeight"))}
            >
              <Block color="red" text="default content" height={100} />
            </AjaxContentWithContext>
          </Grid.Item>
        </Grid>
      </AjaxContentContainer>
    </Section>
  ))
  .add("AjaxContext HashUrl", () => (
    <Section>
      <AjaxContentContainer>
        <Grid variant="even-2">
          <Grid.Item>
            <VerticalNav>
              <VerticalNav.Menu label="Todos">
                <VerticalNav.Item
                  label="One Todo"
                  href="http://demo4923211.mockable.io/ajaxcontenttest2"
                  isSelected={true}
                  isAjax={true}
                  isUrlHashActive={true}
                />
                <VerticalNav.Item
                  label="Two Todos"
                  href="https://jsonplaceholder.typicode.com/todos/2"
                  isAjax={true}
                  isUrlHashActive={true}
                />
              </VerticalNav.Menu>
            </VerticalNav>
          </Grid.Item>
          <Grid.Item>
            <AjaxContentWithContext
              failedContent={text(
                "failedContent",
                "Failed to retrieve content"
              )}
              loadingLabel={text("loadingLabel", "Loading")}
              minHeight={parseInt(text("minHeight"))}
            >
              <Block color="red" text="default content" height={100} />
            </AjaxContentWithContext>
          </Grid.Item>
        </Grid>
      </AjaxContentContainer>
    </Section>
  ))

  .add("AjaxContext Rehydrated", () => (
    <StaticRenderer>
      <Section>
        <AjaxContentContainer>
          <Grid variant="even-2">
            <Grid.Item>
              <VerticalNav>
                <VerticalNav.Menu label="Todos">
                  <VerticalNav.Item
                    label="One Todo"
                    href="https://jsonplaceholder.typicode.com/todos/1"
                    isSelected={true}
                  />
                  <VerticalNav.Item
                    label="Two Todos"
                    href="https://jsonplaceholder.typicode.com/todos/2"
                  />
                </VerticalNav.Menu>
              </VerticalNav>
            </Grid.Item>
            <Grid.Item>
              <AjaxContentWithContext
                failedContent={text(
                  "failedContent",
                  "Failed to retrieve content"
                )}
                loadingLabel={text("loadingLabel", "Loading")}
                minHeight={parseInt(text("minHeight"))}
              >
                <Block color="red" text="default content" height={100} />
              </AjaxContentWithContext>
            </Grid.Item>
          </Grid>
        </AjaxContentContainer>
      </Section>
    </StaticRenderer>
  ))
  .add("Singlemenu", () => (
    <div style={{ width: "360px" }}>
      <VerticalNav>
        <VerticalNav.Menu label="Development">
          <VerticalNav.Menu label="MRN Datebase Models & Implementation Guide">
            <VerticalNav.Menu label="Story Construction & News Coding">
              <VerticalNav.Item
                label="Nested listing A"
                href="#"
                isSelected={true}
                iconType={<Icon path="./icons/ui/grey/tick-07.svg" size="s" />}
              />
            </VerticalNav.Menu>
          </VerticalNav.Menu>
        </VerticalNav.Menu>
      </VerticalNav>
    </div>
  ))
  .add("Language: Arabic (RTL)", () => (
    <div style={{ width: "360px" }}>
      <Language code="ar">
        <VerticalNav>
          <VerticalNav.Menu label="Overview">
            <VerticalNav.Item label="Overview 1" href="#" />
            <VerticalNav.Item label="Overview 2" href="#" />
          </VerticalNav.Menu>
          <VerticalNav.Menu label="Development">
            <VerticalNav.Item label="Transport API - C Edition" href="#" />
            <VerticalNav.Item label="Message API - C++ Edition" href="#" />
            <VerticalNav.Menu label="MRN Datebase Models & Implementation Guide">
              <VerticalNav.Item label="Introductions" href="#" />
              <VerticalNav.Item label="Real-time news" href="#" />
              <VerticalNav.Menu label="Story Construction & News Coding">
                <VerticalNav.Item
                  label="Nested listing A"
                  href="#"
                  isSelected={true}
                  iconType={
                    <Icon path="./icons/ui/grey/tick-07.svg" size="s" />
                  }
                />
                <VerticalNav.Item
                  label="Nested listing B"
                  href="#"
                  iconType={
                    <Icon path="./icons/ui/grey/tick-07.svg" size="s" />
                  }
                />
              </VerticalNav.Menu>
            </VerticalNav.Menu>
          </VerticalNav.Menu>
          <VerticalNav.Item label="FAQs" href="#" />
          <VerticalNav.Item label="Release Notes" href="#" />
        </VerticalNav>
      </Language>
    </div>
  ))
  .add("Rehydrated", () => (
    <StaticRenderer>
      <div style={{ width: "360px" }}>
        <VerticalNav>
          <VerticalNav.Menu
            label="Overview"
            iconType={<Icon path="./icons/ui/grey/tick-07.svg" size="s" />}
          >
            <VerticalNav.Item label="Overview 1" href="#" />
            <VerticalNav.Item label="Overview 2" href="#" />
          </VerticalNav.Menu>
          <VerticalNav.Menu label="Development">
            <VerticalNav.Item label="Transport API - C Edition" href="#" />
            <VerticalNav.Item label="Message API - C++ Edition" href="#" />
            <VerticalNav.Menu label="MRN Datebase Models & Implementation Guide">
              <VerticalNav.Item label="Introductions" href="#" />
              <VerticalNav.Item label="Real-time news" href="#" />
              <VerticalNav.Menu label="Story Construction & News Coding">
                <VerticalNav.Item
                  label="Nested listing A"
                  href="#"
                  isSelected={true}
                  iconType={
                    <Icon path="./icons/ui/grey/tick-07.svg" size="s" />
                  }
                />
              </VerticalNav.Menu>
            </VerticalNav.Menu>
          </VerticalNav.Menu>
          <VerticalNav.Item label="FAQs" href="#" />
          <VerticalNav.Item label="Release Notes" href="#" />
        </VerticalNav>
      </div>
    </StaticRenderer>
  ));
